import { TASK_STATUS } from './task-status.enum';

export const TASK_STATUSES_LOOKUP = [
  { value: TASK_STATUS.NOT_STARTED, description: TASK_STATUS.NOT_STARTED },
  { value: TASK_STATUS.NEED_ASSISTANCE, description: TASK_STATUS.NEED_ASSISTANCE },
  { value: TASK_STATUS.IN_PROGRESS, description: TASK_STATUS.IN_PROGRESS },
  { value: TASK_STATUS.DEFERRED, description: TASK_STATUS.DEFERRED },
  { value: TASK_STATUS.COMPLETED, description: TASK_STATUS.COMPLETED },
];
